<template>
  <div class="navbar-wrapper">
    <nav class="navbar navbar-default navbar-static-top">
      <div class="container-fluid">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header">
          <!-- <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <a class="navbar-brand" href="" @click.prevent><img :src="logoUrl || ''" class="img-responsive"></a> -->
          <!-- <a class="navbar-brand" href="index.html"><img src="../../assets/images/logo-invert.png" class="img-responsive"></a> -->
        </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <!-- <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <ul class="nav navbar-nav navbar-right">
            <li><a href="index.html">Home</a></li>
            <li><a href="enter-items-earn-rewards.html">Earn Points</a></li>
            <li><a href="redeem-points-rewards.html">Redeem Points</a></li>
            <li><a href="#">Faq’s/Terms &amp; Conditions</a></li>
            <li><a href="logged-in.html">My Account</a></li>
            <li><a href="#">Logout</a></li>
          </ul>
        </div> -->
      </div><!-- /.container-fluid -->
    </nav>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('loyaltyProgram', {
      logoUrl: state => state.program.company ? state.program.company.logo.url : ''
    })
  },
  methods: {
    logout () {
      localStorage.removeItem('jwtToken')
      localStorage.removeItem('user')
      this.$router.push({
        name: 'ClientLogin'
      })
    }
  }
}
</script>
